import React from "react"
import profilePic from './media/profile_portfolio-removebg-preview.png'
import './styles/Contact.css'

function SentEmail(){

    return(
        <div className="emailSent-wrapper">
           <p className="emailSent-text">Your message was sent!</p>
        </div>
    )
}

export default SentEmail